module.exports = __webpack_public_path__ + "media/images/icon_nav_ranking_black-28fe138b76f968dd7d5c82d247e5807a.svg";